<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<app-new-modal-message
  #modalAvisos
  [showFecharBtn]="false"
></app-new-modal-message>

<div class="position-relative">
  <form [formGroup]="identificacaoForm" class="forms">
    <div class="row">
      <div class="col-xs-12 info-container">
        <h2>Demais dados</h2>

        <div *ngIf="showValidacaoCelular">
        
          <app-panel-custom title="Biometria - Foto do Cliente" color="blue">
            <app-webcam name="biometria" formControlName="biometria" [isLojistaPiloto]="isLojistaPiloto"
              [propostaId]="proposta.id" [isAceitaImagem]="isAceitaImagem" [isEnabledFotoAndEnviar]="isEnabledFotoAndEnviar()"
              (showLoader)="showLoader = $event"></app-webcam>
          </app-panel-custom>
        
        </div>
        
        <div *ngIf="showValidacaoBiometria">
        
          <app-panel-custom title="autenticação do Cliente" subtitle="Validação de Celular, aceite de termos e Biometria Manual"
            color="blue">
            <app-autenticacao [isBiometriaAtiva]="biometriaAtiva"></app-autenticacao>
          </app-panel-custom>
        
        </div>

        <app-panel-custom title="Descrição dos Produtos" color="blue">
          <app-mercadoria
            [index]="produto"
            [indentificacaoForm]="identificacaoForm"
            (selfDestructEmitter)="destroyProduto($event)"
            *ngFor="let produto of filterProdutos()"
          ></app-mercadoria>

          <div class="produtos">
            <app-btn-small
              color="primary"
              title=" Adicionar produto"
              (click)="addProduto()"
              class="adicionar-produto"
            >
              <span class="fa fa-plus"></span>
            </app-btn-small>
          </div>

          <div class="form-group show-total">
            <div class="inputs">
              <label for="valorTotalProdutos">Valor Total dos Produtos</label>
              <input
                class="form-control d-none"
                type="text"
                placeholder="R$ 00.000,00"
                formControlName="valorTotalProdutos"
                name="valorTotalProdutos"
                readonly
              />
              <p>{{ valorTotalProdutos | currency: 'BRL':'symbol' }}</p>
            </div>
          </div>

          <div class="form-group show-total">
            <div class="inputs">
              <label for="valorSolicitado">Valor Solicitado</label>
              <input
                class="form-control d-none"
                type="text"
                placeholder="R$ 00.000,00"
                formControlName="valorSolicitado"
                name="valorSolicitado"
                readonly
              />
              <p>{{ valorSolicitado | currency: 'BRL':'symbol' }}</p>
            </div>
          </div>

          <div
            *ngIf="!valorMercadoriasIgualSolicitado"
            class="alert alert-danger alert-dismissable"
          >
            <strong
              >Valor total dos produtos diferente do valor solicitado!
            </strong>
          </div>
        </app-panel-custom>

        <app-panel-custom title="Documentos Adicionais" color="blue">
          <div class="row">
            <div class="col-xs-12">
              <app-upload-arquivos
                #uploadArquivos
                [documentos]="documents"
                [idFicha]="proposta.id"
                [cliente]="proposta.cliente"
                [showEnviado]="true"
                [showUploadedItens]="true"
                [enableSendButton]="true"
                [utilizaDropComponent]="true"
                [pr30]="true"
                [origem]="6"
              ></app-upload-arquivos>
            </div>
          </div>
        </app-panel-custom>

        <h2>Informações Adicionais (Opcional)</h2>
        <div class="textarea-observacoes white-box">
          <textarea
            rows="10"
            cols="90"
            maxlength="4000"
            name="observacoes"
            formControlName="observacoes"
          ></textarea>
        </div>
      </div>
    </div>
  </form>

  <app-botao-navegacao
    *ngIf="!showTryAgainButton"
    (previous)="onClickPrevious()"
    (next)="onClickNext()"
    [previousShow]="true"
    [nextShow]="true"
    [nextEnabled]="valid"
    nextLabel="Analisar"
  ></app-botao-navegacao>

  <div class="btn-analisar-novamente">
    <button
      *ngIf="showTryAgainButton"
      class="bt-go btn btn-full-orange"
      (click)="onClickTryAgain()"
      [disabled]="!valid"
    >
      Analisar novamente
    </button>
  </div>
</div>

<div class="loader-phases" *ngIf="showLoaderPhases">
  <app-loader-phases
    [phases]="['Aguarde, validando informações.']"
  ></app-loader-phases>
</div>
